import { Entity } from './api';

/**
 *  Activate deps navigation by location
 *  When user open screen with below hash urls this function build params for call deps navigation
 */
export const entityMetadataFnsRelatedToLocation = {
  '#/workflows/edit': (hash: string) => {
    const [entityName, entityVersion = '0'] = hash.split('/').slice(3, 5);
    return {
      entityType: 'Workflow',
      entityName,
      entityVersion: +parseInt(entityVersion)
    };
  },
  '#/prototypes/edit': (hash: string) => {
    const [entityName] = hash.split('/').slice(3, 4);
    return {
      entityType: 'DataContext',
      entityName
    };
  },
  '#/providers/edit': (hash: string) => {
    const [entityName] = hash.split('/').slice(3, 4);
    return {
      entityType: 'DataProvider',
      entityName
    };
  },
  '#/models/invoke': (hash: string) => {
    const [entityName] = hash.split('/').slice(3, 4);
    return {
      entityType: 'Model',
      entityName
    };
  },
  '#/models/edit': (hash: string) => {
    const [entityName] = hash.split('/').slice(3, 4);
    return {
      entityType: 'Model',
      entityName
    };
  },
  '#/functions/details': (hash: string) => {
    const [entityName] = hash.split('/').slice(3, 4);
    return {
      entityType: 'LocalFunction',
      entityName
    };
  },
  '#/functions/remote/browse': (hash: string) => {
    const [entityName] = hash.split('/').slice(4, 5);
    return {
      entityType: 'Package',
      entityName
    };
  },
  '#/parametertable/edit': (hash: string) => {
    const [entityName, entityVersion = '0'] = hash.split('/').slice(3, 5);
    return {
      entityType: 'ParametersTable',
      entityName,
      entityVersion: +parseInt(entityVersion)
    };
  },
  '#/signals/edit': (hash: string) => {
    const [entityName] = hash.split('/').slice(3, 4);
    return {
      entityType: 'Signal',
      entityName
    };
  },
  '#/components/package': (hash: string) => {
    const [entityName] = hash.split('/').slice(3, 4);
    return {
      entityType: 'Component',
      entityName
    };
  }
};

export function getRequestLocationKey() {
  const hash = window.location.hash;
  const requestLocationKey = Object.keys(entityMetadataFnsRelatedToLocation).find(rule => hash.includes(rule));

  return requestLocationKey as keyof typeof entityMetadataFnsRelatedToLocation;
}

export function getRequestMetadata() {
  const requestLocationKey = getRequestLocationKey();
  const entityMetadataFn = entityMetadataFnsRelatedToLocation[requestLocationKey];
  return entityMetadataFn && entityMetadataFn(window.location.hash) as Entity;
}
